import { useQuery } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { UsersApiAdapter } from '../adapters/UsersApiAdapter';
import { Service } from '../services/Service';

const INVITATION_INFO_QUERY_KEY = ['invitation', 'info'] as const;

/**
 * Hook para obtener información sobre una invitación
 * @param token - Token de la invitación
 * @param enabled - Si debe ejecutarse la query (por defecto true si hay token)
 */
export const useInvitationInfo = (token: string | null, enabled: boolean = true) => {
  const httpClient = createHttpClient(apiClientWH);
  const usersAdapter = new UsersApiAdapter(httpClient);
  const usersService = new Service(usersAdapter);

  return useQuery({
    queryKey: [...INVITATION_INFO_QUERY_KEY, token],
    queryFn: () => {
      if (!token) {
        throw new Error('Token is required');
      }
      return usersService.getInvitationInfo(token);
    },
    enabled: enabled && !!token,
    staleTime: 5 * 60 * 1000, // 5 minutos
    retry: false, // No reintentar si falla (token inválido/expirado)
  });
};

